const selectedAddressModal = {
  modal: {
    justifyContent: "center",
    alignItems: "center",
    top: "50%",
    left: "50%",
    width: "100%",
    minHeight: "352px",
    height: "fit-content",
    bottom: "50%",
    margin: "0 auto",
    zIndex: 20,
    position: "absolute",
    transform: "translate(-50%, -50%)",
    boxSizing: "border-box",
    maxHeight: "100%",
    backgroundColor: "white"
  },
  closeIcon: {
    position: "absolute",
    top: "5px",
    right: "5px",
    cursor: "pointer",
    color: "black",
    height: "20px",
    width: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid",
    borderRadius: "50%"
  }
};

export default selectedAddressModal;
